<template>
  <div id='app' data-app="true">
    <nuxt/>
  </div>
</template>
<script>
export default {
  middleware: ['redirectDomain']
}
</script>



// WEBPACK FOOTER //
// layouts/default.vue